module.exports = __webpack_public_path__ + "static/media/ivan.e6499bdc.png";